import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Utils from '../../utility';
import { GlobalService } from '../../../services/global.service';
import { ModalService } from '../../../shared/modal/modal.service';
import { FundingSourceComponent } from '../../../shared/modal/funding-source/funding-source.component';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { CommonModule, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-cola',
  templateUrl: './cola.component.html',
  styleUrls: ['./cola.component.css']
})
export class COLAComponent implements OnInit {
  modalName: string;
  data;
  colaForm: FormGroup;
  dataSource: any[] = [];//MatTableDataSource<reportData>;
  currentYear = new Date().getFullYear();

  constructor(private formBuilder: FormBuilder, private globalService: GlobalService, private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe, private modalService: ModalService, public dialogRef: MatDialogRef<FundingSourceComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.data = data;
    this.modalName = data.modalName;
  }

  ngOnInit() {

    this.colaForm = this.formBuilder.group({
      inflationRate: [Utils.formatToPercentage(this.data.inflationRate), [Validators.required, Validators.maxLength(5), Validators.max(10), Validators.min(0), this.noLoneSymbolValidator()]],
      colaYearOne: [Utils.formatToPercentage(this.data.colaYearOne), [Validators.required, Validators.maxLength(5), Validators.max(10), Validators.min(0), this.noLoneSymbolValidator()]],
      colaYearTwo: [Utils.formatToPercentage(this.data.colaYearTwo), [Validators.required, Validators.maxLength(5), Validators.max(10), Validators.min(0), this.noLoneSymbolValidator()]],
      colaYearThree: [Utils.formatToPercentage(this.data.colaYearThree), [Validators.required, Validators.maxLength(5), Validators.max(10), Validators.min(0), this.noLoneSymbolValidator()]],
      colaYearFourPlus: [Utils.formatToPercentage(this.data.colaYearFourPlus), [Validators.required, Validators.maxLength(5), Validators.max(10), Validators.min(0), this.noLoneSymbolValidator()]],
    });
    
  }

  formatNumber(amount) {
    return Math.round(amount);
  }

  formatCurrency(val) {
    return Utils.formatToCurrency(Utils.formatToNumber(val));
  }

  formatNumber3(val) {
    return Utils.formatToNumber(val);
  }

  noLoneSymbolValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      
      if (!value) return null; // Allow empty input
  
      // Strict regex pattern:
      const validPattern = /^-?\d+(\.\d+)?%?$/;
  
      if (!validPattern.test(value)) {
        return { invalidFormat: true };
      }
  
      if (value === '%') {
        return { invalidFormat: true };
      }
  
      return null;
    };
  }

  formatPercentage(event, scenario, precision = 2, allowDecimal = true){
    const key = event.keyCode || event.charCode;
    var value = event.target.value;
    var negativeValue = (value.includes('-')) ? true : false;
    if (!negativeValue) {
      if (!allowDecimal) {
        value = value.replace(/\D/g, '');
      } else {
        value = value.replace('%', '');
        if (value.includes('.'))
          value = `${value.split('.')[0]}.${value.split('.')[1].substring(0,precision)}`
      }
    } else {
      value = value.replace('%', '');
      if (value.includes('.'))
        value = `${value.split('.')[0]}.${value.split('.')[1].substring(0,precision)}`
    }

    if (value.includes(','))
      value = `${value.replace(',','')}`

    var isDeleting = false;
    if (key === 8 || key === 46) {
      isDeleting = true;
    }

    if (value != '') {
      if (scenario == 'inflationRate') {
        this.colaForm.controls['inflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'colaYearOne') {
        this.colaForm.controls['colaYearOne'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'colaYearTwo') {
        this.colaForm.controls['colaYearTwo'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'colaYearThree') {
        this.colaForm.controls['colaYearThree'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
      if (scenario == 'colaYearFourPlus') {
        this.colaForm.controls['colaYearFourPlus'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
      }
    } else {
      if (scenario == 'inflationRate') {
        this.colaForm.controls['inflationRate'].patchValue('');
      }
      if (scenario == 'colaYearOne') {
        this.colaForm.controls['colaYearOne'].patchValue('');
      }
      if (scenario == 'colaYearTwo') {
        this.colaForm.controls['colaYearTwo'].patchValue('');
      }
      if (scenario == 'colaYearThree') {
        this.colaForm.controls['colaYearThree'].patchValue('');
      }
      if (scenario == 'colaYearFourPlus') {
        this.colaForm.controls['colaYearFourPlus'].patchValue('');
      }
    }
  }

  convertObjectForClose(){
    //console.log('object before', this.colaForm.value);

    this.colaForm.controls['inflationRate'].patchValue(Utils.removePercentageFormatting(this.colaForm.value.inflationRate));
    this.colaForm.controls['colaYearOne'].patchValue(Utils.removePercentageFormatting(this.colaForm.value.colaYearOne));
    this.colaForm.controls['colaYearTwo'].patchValue(Utils.removePercentageFormatting(this.colaForm.value.colaYearTwo));
    this.colaForm.controls['colaYearThree'].patchValue(Utils.removePercentageFormatting(this.colaForm.value.colaYearThree));
    this.colaForm.controls['colaYearFourPlus'].patchValue(Utils.removePercentageFormatting(this.colaForm.value.colaYearFourPlus));

    //console.log('object after', this.colaForm.value);

    return this.colaForm.value;
  }

  close(update): void {
    if(update){
      //return the list of funding sources we added to the illustration for recalcs
      this.dialogRef.close(this.convertObjectForClose());
    }else{
      if(this.colaForm.value.length > 0){
        this.dialogRef.close(this.convertObjectForClose());
      } else{
        //If in here, that means nothing was ever added to the funding source
        this.dialogRef.close();
      }
    }
  }

}

